/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import { Helmet } from 'react-helmet';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Styles from './Styles';
import Card from './Card';
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from './cardUtils';
import TheLayout from '../../layout/TheLayout';
import { updateCard } from '../../redux/actions/payment';
import ModalCommon from '../Util/Modal/ModalCommon';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const keywords = ['TERRA', 'about', 'TERRAについて'];

const MasterCard = () => {
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const maskedCardNumber = useSelector((state) => state.auth.masked_card_number, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);

  const [textMessage, setTextMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (values) => {
    const companyUser = JSON.parse(localStorage.getItem('company'));
    const sbpsMerchantId = companyUser?.sbp?.merchant_id;
    const sbpsServiceId = companyUser?.sbp?.service_id;
    await sleep(300);
    const { number, expiry, cvc } = values;
    if (number === undefined || number === undefined || cvc === undefined || number === '' || expiry === '' || cvc === '') {
      setError('完全な情報を入力してください');
    } else {
      setError('');
      // eslint-disable-next-line no-use-before-define
      getTokenSBPS(sbpsMerchantId, sbpsServiceId, number, expiry, cvc);
    }
  };

  if (!isLoggedIn) {
    return <Redirect to="/login" />;
  }
  // ワンタイムトークン生成
  const getTokenSBPS = (sbpsMerchantId, sbpsServiceId, number, expiration, cvv) => {
    try {
      window.com_sbps_system.generateToken(
        {
          merchantId: sbpsMerchantId,
          serviceId: sbpsServiceId,
          ccNumber: number?.replace(/\s+/g, ''),
          ccExpiration: `20${expiration?.substr(3, 2)}${expiration?.substr(0, 2)}`,
          securityCode: cvv,
        },
        async (response) => {
          // const apiKey = 'fAKhaTA9ecrQNABR2thb';
          if (response.result === 'OK') {
            const objectCard = {
              credit_card_token: response.tokenResponse.token,
              credit_card_token_key: response.tokenResponse.tokenKey,
              masked_card_number: response.tokenResponse.maskedCcNumber,
              company_id: Number(process.env.REACT_APP_COMPANY_ID),
              card_expire_at: response.tokenResponse.ccExpiration,
            };
            const result = await dispatch(updateCard(accessToken, objectCard));
            if (result !== undefined) {
              setTextMessage('クレジットカードの更新が完了しました。');
            } else {
              setTextMessage('不正なカード情報です。入力情報をご確認ください。');
            }
          } else {
            setTextMessage('不正なカード情報です。入力情報をご確認ください。');
          }
          setOpen(true);
        },
      );
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>TERRAについて｜株式会社TERRA</title>
        <script
          type="text/javascript"
          src="https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js"
        />
      </Helmet>
      <Styles>

        <Form
          style={{ padding: 10 }}
          onSubmit={onSubmit}
          render={({
            handleSubmit,
            submitting,
            values,
            active,
          }) => (
            <form onSubmit={handleSubmit}>
              <b>
                現在登録しているクレジットカード :
                {' '}
                { maskedCardNumber }
              </b>
              <hr />
              <b style={{ display: 'flex', justifyContent: 'center' }}>クレジットカード更新</b>
              <Card
                number={values.number || ''}
                name={values.name || ''}
                expiry={values.expiry || ''}
                cvc={values.cvc || ''}
                focused={active}
              />
              <div>
                <Field
                  autocomplete="off"
                  name="number"
                  component="input"
                  type="text"
                  pattern="[\d| ]{16,22}"
                  placeholder="Card Number"
                  format={formatCreditCardNumber}
                />
              </div>
              <div>
                <Field
                  name="name"
                  component="input"
                  type="text"
                  placeholder="Name"
                />
              </div>
              <div>
                <Field
                  name="expiry"
                  component="input"
                  type="text"
                  pattern="\d\d/\d\d"
                  placeholder="Valid Thru"
                  format={formatExpirationDate}
                />
                <Field
                  className="cvc-mobile"
                  name="cvc"
                  component="input"
                  type="text"
                  pattern="\d{3,4}"
                  placeholder="CVC"
                  format={formatCVC}
                />
              </div>
              <p style={{ color: 'red', marginLeft: 20, fontWeight: 'normal' }}>{error}</p>
              <div className="buttons">
                <button type="submit" disabled={submitting}>
                  クレジットカードを更新する
                </button>
              </div>
              {/* <h2>Values</h2>
              <pre>{JSON.stringify(values, 0, 2)}</pre> */}
            </form>
          )}
        />

        <ModalCommon isOpen={open} message={textMessage} handleCloseModal={() => setOpen(false)} />
      </Styles>
    </TheLayout>
  );
};

export default MasterCard;
